export default __webpack_public_path__ + "static/media/Friends_and_Family.8ba85541.pdf";